import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { ContentProvider } from '@/context/ContentContext';
import { Layout } from '@/components/layout/Layout';

import Home from '@/pages/Home';
import About from '@/pages/About';
import Capabilities from '@/pages/Capabilities';
import Categories from '@/pages/Categories';
import CategoryDetail from '@/pages/CategoryDetail';
import Suppliers from '@/pages/Suppliers';
import Buyers from '@/pages/Buyers';
import Contact from '@/pages/Contact';
import Policy from '@/pages/Policy';
import NotFound from '@/pages/NotFound';
import InstitutionalBuyers from '@/pages/InstitutionalBuyers';
import RequestBulkQuote from '@/pages/RequestBulkQuote';
import SolutionPage from '@/components/b2b/SolutionPage';
import { SOLUTIONS } from '@/data/b2b';
import AdminLogin from '@/pages/admin/AdminLogin';
import AdminDashboard from '@/pages/admin/AdminDashboard';

const RequireAdmin = ({ children }) => {
  const token = localStorage.getItem('ophir_admin_token');
  return token ? children : <Navigate to="/admin" replace />;
};

function App() {
  return (
    <ContentProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/capabilities" element={<Capabilities />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/categories/:slug" element={<CategoryDetail />} />
            <Route path="/suppliers" element={<Suppliers />} />
            <Route path="/buyers" element={<Buyers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/institutional-buyers" element={<InstitutionalBuyers />} />
            <Route path="/request-bulk-quote" element={<RequestBulkQuote />} />
            {Object.keys(SOLUTIONS).map((slug) => (
              <Route key={slug} path={SOLUTIONS[slug].path} element={<SolutionPage slug={slug} />} />
            ))}
            <Route path="/privacy" element={<Policy kind="privacy" />} />
            <Route path="/terms" element={<Policy kind="terms" />} />
            <Route path="/accessibility" element={<Policy kind="accessibility" />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </ContentProvider>
  );
}

export default App;
